<template>
    <div class="container">
        <div class="common-header-wrap">
        <mt-header title="货源商城" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
        </div>
        <div class="common-goods-list">
            <div class="ui-goodslist-filter">
                <ul class="filter-list">
                    <li class="item sortactive"
                        v-for='item in sortkey'
                        :key='item.id'
                        @click='setActiveSortkey()'>
                        <a>{{ item.name }}</a>
                        <span class="iconfont" :class="isShowMore?'active':''" v-if="item.isMore">&#xe6ea;</span>
                    </li>
                </ul>
                <div class="sort-model" v-if='isShowMore'>
                    <div v-for='item in childSort' :key='item.gc_id' @click='getSortChild(item)' :class="{'active': item.gc_id == activeCateIndex}">
                        <a>{{item.gc_name}}</a>
                        <span class="iconfont" v-if="item.gc_id == activeCateIndex">&#xe69b;</span>
                    </div>
                </div>
            </div>
            <div class="goodslist-body show-goods-list" >
                <!-- 无限加载滚动列表 -->
                <div class="flex-wrapper" v-infinite-scroll="getMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                    <div class="ui-product-body" v-for='(item, index) in goodsList' v-bind:key='index'>
                        <div class="list">
                            <div class="ui-image-wrapper">
                                <img class="product-img" v-lazy="item.goods_image_url">
                            </div>
                            <div class="flex-right">
                                <div class="product-header">
                                    <h3 class="title clear-bottom" style="-webkit-box-orient:vertical">{{ item.goods_name }}</h3>
                                </div>
                                <div class="p-price" style="-webkit-box-orient:vertical">
                                    ¥{{ item.goods_price }}
                                </div>
                                <div class="product-operate">
                                    <div class="ui-number">
                                        <div class="reduce ui-common"  @click.stop="reduceNumber(item)" :class="{ 'reduce-opacity': item.goods_num <= 1 }"> - </div>
                                        <input type="number" min="1" class="number" value="1" v-model="item.goods_num" readonly/>
                                        <div class="add ui-common" @click.stop="addNumber(item)"> + </div>
                                    </div>
                                    <mt-button class="buttom" size="small" type="primary" @click="confirmSupplyGoods(item)">一键铺货</mt-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="loading-wrapper" v-if="goodsList.length > 0">
                        <p class="common-no-more" v-if='!isMore'>没有更多了</p>
                        <mt-spinner type="triple-bounce" color='#e93b3d' v-if='isMore'></mt-spinner>
                    </div>
                    <empty-record v-if='goodsList.length <= 0 && !isMore'></empty-record>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import { supplyGoodsList, confirmSupplyGoodsByNum } from '../../../api/sellerGoods'
import { Toast } from 'mint-ui'
export default {
  name: 'SellerSupplyGoods',
  components: {
    EmptyRecord
  },
  data () {
    return {
      controller: 'sellerindex',
      sortkey: [
        {
          key: '',
          order: '',
          name: '商品分类',
          isMore: true,
          id: 1
        }
      ],
      isShowMore: false,
      childSort: [],
      activeCateIndex: -1,
      params: {
        page: 1,
        cate_id: ''
      },
      goodsList: [], // 商品列表
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  created () {
    this.getGoodsList()
  },
  methods: {
    /**
     * getGoodsList: 获取商品列表
     * @param：  ispush ？ true ：false 是否需要向商品列表追加数据
     */
    getGoodsList (ispush) {
      supplyGoodsList(
        this.controller,
        this.params
      ).then(res => {
        res.result.goods.map(item => { item.goods_num = 1 })
        this.childSort = res.result.cat
        this.buildData(ispush, res)
      })
    },
    /**
     * getList: 构建数据
     * @param: ispush 是否改变向元数据追加数据
     * @param: res 接口请求返回的数据
     */
    buildData (ispush, res) {
      if (res) {
        if (ispush) {
          this.goodsList = this.goodsList.concat(res.result.goods)
        } else {
          this.goodsList = res.result.goods
        }
        this.isMore = Boolean(res.result.hasmore)
      }
    },
    /*
    * getMore: 无限滚动加载
    */
    getMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getGoodsList(true)
      }
    },
    /**
     *  setActiveSortkey: 点击切换数据并设置选中的样式
     */
    setActiveSortkey () {
      this.isShowMore = !this.isShowMore
    },
    /**
     *  getSortChild: 获取综合筛选的子集， 关闭父级的阴影模态框， 关闭子集， 获取列表数据
     */
    getSortChild (item) {
      this.activeCateIndex = item.gc_id
      this.goodsList = []
      this.loading = false
      this.isMore = true
      this.params.page = 1
      this.params.cate_id = item.gc_id
      this.isShowMore = !this.isShowMore
      this.getGoodsList()
    },
    /*
    *  reduceNumber: 数量减少
    */
    reduceNumber (item) {
      if (item.goods_num > 1) {
        item.goods_num--
      }
    },
    /*
    *  addNumber: 数量增加
    */
    addNumber (item) {
      item.goods_num++
    },
    /*
    *  confirmSupplyGoods: 一键铺货
    */
    confirmSupplyGoods (item) {
      let supplyGoodsParam = {
        goods_id: item.goods_id,
        nums: item.goods_num
      }
      confirmSupplyGoodsByNum(this.controller, supplyGoodsParam)
        .then(res => {
          Toast('铺货成功')
        })
        .catch(err => {
          Toast(err.message)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
    .ui-goodslist-filter {
        width: auto;
        ul.filter-list{
            display: flex;
            width: auto;
            justify-content: space-around;
            align-content: center;
            align-items: center;
            border: 0;
            border-top: .045rem solid #E8EAED;
            border-bottom: .045rem solid #E8EAED;
            li{
                font-size: .7rem;
                color: #333;
                border-bottom: .1rem solid transparent;
                position: relative;
                flex-basis: 4.54rem;
                text-align: center;
                height: 1.9rem;
                padding: 0;
                line-height: 1.9rem;
                a {
                    height: 1.9rem;
                    display: inline-block;
                }
                img {
                    height: .18rem;
                    width: .36rem;
                    vertical-align: middle;
                }
                .iconfont{display: inline-block}
            }
            li.sortactive {
                border-bottom-color:#e93b3d;
                a {
                    color:$primaryColor;
                }
                .iconfont{color:#e93b3d;}
                .iconfont.active{transform: rotate(180deg);}
            }
            li.sortnormal {
                border-bottom-color: transparent;
                a {
                    color: #333;
                }
            }
            .arrow-icon {
                width: .54rem;
                height: .54rem;
            }
        }
        .sort-model {
            position: absolute;
            left: 0;
            width: 100%;
            z-index: 10;
            div {
                color: #333;
                padding: .68rem;
                font-size: .59rem;
                background-color: #fff;
                margin: 0;
                border-bottom: .045rem solid #E8EAED;
                cursor: pointer;
                display: flex;
                width: auto;
                justify-content: space-between;
                align-content: center;
                align-items: center;
                img {
                    float: right;
                    width: .7rem;
                    height: .7rem;
                }
                &.active {
                    color: $primaryColor;
                }
            }
        }
    }
    .ui-product-body {
        border-bottom: .045rem solid rgba(232,234,237,1);
        .list {
            display: flex;
            width: auto;
            align-items: center;
            justify-content: space-between;
            margin: .5rem .45rem;
            position: relative;
            div.ui-image-wrapper {
                width: 5rem;
                height: 5rem;
                position: relative;
                display: flex;
                justify-content: center;
                align-content: center;
                align-items: center;
                flex-basis: 5rem;
                flex-shrink: 0;
                background-position:center center!important;
                background-size:4.54rem 4.54rem;
                background-repeat:no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;

                img.product-img{
                    width: 5rem;
                    height: 5rem;
                    flex-basis: 5rem;
                    flex-shrink: 0;
                }
                img.product-img[lazy=loading] {
                    width: 1.36rem;
                    height: 1.36rem;
                }
                img.product-im[lazy=error] {
                    width: 1.36rem;
                    height: 1.36rem;
                }
                img.product-img[lazy=loaded] {
                    width: 5rem;
                    height: 5rem;
                    flex-basis: 5rem;
                    flex-shrink: 0;
                    background:rgba(255,255,255,1);
                }
                span {
                    position: absolute;
                    height:.9rem;
                    background:rgba(243,244,245,1);
                    line-height: .9rem;
                    text-align: center;
                    font-size:.63rem;
                    color:$primaryColor;
                    width: 5rem;
                    bottom: 0;
                    left: 0;
                }
            }
            .flex-right {
                padding-left: .63rem;
                width: 100%;
                position:relative;
                .title {
                    color: #333;
                    font-size: .7rem;
                    line-height:1rem;
                    height:2rem;
                    font-weight: normal;
                    overflow: hidden;
                    margin-bottom: .4rem;
                    &.clear-bottom {
                        margin-bottom: 0;
                    }
                }
                .product-header {
                    margin-bottom: .5rem;
                    display: flex;
                    align-items: center;
                }
                .p-price {
                    color: #e93b3d;
                    font-size:0.7rem;
                }
                .product-operate {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    margin-top: .3rem;
                }
                .ui-number {
                  height: 1.2rem;
                  display: flex;
                  margin-right: 1rem;
                  border-radius: 0.15rem 0 0 0.15rem;
                  input,
                  div {
                    height: 1.2rem;
                    text-align: center;
                    color: #404245;
                    display: inline-block;
                    padding: 0;
                    margin: 0;
                    border: 0;
                    outline-offset: 0;
                  }
                .ui-common {
                  line-height: 1.2rem;
                  width: 1.3rem;
                  height: 1.2rem;
                  border: 1px solid #c7c7cd;
                  cursor: pointer;
                }
                .reduce {
                  border-right: 0;
                }
                .reduce-opacity {
                  opacity: 0.4;
                }
                  .add {
                    border-left: 0;
                  }
                  input[type='number'] {
                    width: 1.3rem;
                    border: 1px solid #c7c7cd;
                    border-radius: 0;
                    border-image-width: 0;
                    box-shadow: 0;
                    vertical-align: bottom;
                    &:focus {
                      outline: none;
                    }
                  }
              }
            }
        }
    }

    .filter-attribute{padding:0.5rem;}
    .filter-attribute dl{width:100%;}
    .filter-attribute dt{height:1.2rem;width:100%;overflow: hidden;font-size:0.8rem;color: #333;}
    .filter-attribute dd{}
    .filter-attribute dd a{position: relative;display:inline-block;color: #666;font-size:0.6rem;text-align:center;background-color: #f7f7f7;border-radius:0.2rem;height:1.5rem;line-height:1.5rem;margin:0.5rem 1.5%;width:30%;}
    .filter-attribute dd a.selected{color: #e93b3d;background-color: #fdf0f0;}
    .filter-attribute dd a.selected::after{content: "";position: absolute;right: 0;bottom: 0;width: 15px;height: 15px;border-radius: 0 0 2px 0;background: url("../../../assets/image/home/attribute_selected.png") no-repeat;background-size: 15px auto;overflow: hidden;z-index: 1;}

    .loading-wrapper{text-align: center}
</style>
